export const UPDATE_DMX_DEVICE_PRESET = 'UPDATE_DMX_DEVICE_PRESET';
export const UPDATE_DMX_DEVICE_PRESET_SUCCESSFUL = 'UPDATE_DMX_DEVICE_PRESET_SUCCESSFUL';
export const UPDATE_DMX_DEVICE_PRESET_FAILED = 'UPDATE_DMX_DEVICE_PRESET_FAILED';
